
import { Vue } from "vue-class-component"; //基本需要\
import { store } from "@/store"; //引入仓库
import { getLocalProject } from "@/utils"; //类型
import {
  dispatchGetCaseMonitorList,
  dispatchGetCaseMonitor,
} from "@/store/performance/actions";
import {
  readCaseMonitor,
  readCaseMonitorList,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  // 获取默认数据
  public get monList() {
    return readCaseMonitorList(store);
  }
  public get monText() {
    return readCaseMonitor(store);
  }
  public dialogFormVisible = false;
  public localProject = Number(getLocalProject()); //得到本地的项目
  public info = "";
  public async confirm() {
    this.dialogFormVisible = true;
    await dispatchGetCaseMonitor(store, {
      project: this.localProject,
      id: Number(this.info),
    });
    // let string = "";
    // for (let i in this.monText.case) {
    //   string += i + "：\n";
    //   for (let n in this.monText.case[i]) {
    //     string += this.monText.case[i][n] + "\n";
    //   }
    //   string += "\n";
    // }
  }
  public custom_json = "";
  public mounted() {
    dispatchGetCaseMonitorList(store, {
      project: this.localProject,
    });
  }
}
